export default class Buttons {
	constructor() {
		this.buttons = document.querySelectorAll(".btn, .btn-fill, .btn-secondary, .btn-light");

		this.buttons.forEach((button) => {

			const text = `<span class='label'>${button.innerHTML}</span>`;
			button.innerHTML = text;

			if (button.classList.contains('btn-go') || button.classList.contains('btn-back')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="50" height="54" viewBox="0 0 50 54" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.7803 49.6981L23.5981 53.5714L50 26.7857L23.5981 0L19.7803 3.87236L39.6649 24.046L0 24.046L0 29.5239L39.6649 29.5239L19.7803 49.6981Z" fill="currentColor"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if (button.classList.contains('btn-download')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 0.25C10 0.111929 9.88807 0 9.75 0H2.75C1.23122 0 0 1.23122 0 2.75V16.75C0 18.2688 1.23122 19.5 2.75 19.5H12.75C14.2688 19.5 15.5 18.2688 15.5 16.75V6.89706C15.5 6.75899 15.3881 6.64706 15.25 6.64706H10.75C10.3358 6.64706 10 6.31127 10 5.89706V0.25ZM9.78151 10.9143C10.105 10.6556 10.5769 10.708 10.8357 11.0315C11.0944 11.3549 11.042 11.8269 10.7185 12.0857L8.2246 14.0808C8.09591 14.1861 7.93159 14.2494 7.75248 14.25L7.75006 14.25L7.74373 14.25C7.56768 14.2485 7.40609 14.1864 7.27884 14.0835L4.78151 12.0857C4.45806 11.8269 4.40562 11.3549 4.66438 11.0315C4.92313 10.708 5.3951 10.6556 5.71855 10.9143L7.00006 11.9396V8.5C7.00006 8.08579 7.33584 7.75 7.75006 7.75C8.16427 7.75 8.50006 8.08579 8.50006 8.5V11.9395L9.78151 10.9143Z"/>
    <path d="M11.5 0.574135C11.5 0.38964 11.6926 0.272496 11.8362 0.388386C11.9571 0.485999 12.0658 0.600358 12.1585 0.729549L15.1717 4.92745C15.2403 5.02302 15.166 5.14706 15.0483 5.14706H11.75C11.6119 5.14706 11.5 5.03513 11.5 4.89706V0.574135Z"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if (button.classList.contains('btn-gallery')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 1H16V10M1 4H13V13H1V4Z" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if (button.classList.contains('btn-lang')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.08786 0.982932L8.15892 8.054L7.07107 9.14186L0 2.07079L1.08786 0.982932Z" fill="#34847A"/>
<path d="M14.1422 2.07077L7.07107 9.14186L5.98332 8.05398L13.0544 0.98291L14.1422 2.07077Z" fill="#34847A"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}
		});
	}
}
